import { Component, Input, OnInit } from '@angular/core';
import { IonicModule, Platform } from '@ionic/angular';
import { Avtaler } from '../../../services/avtale/avtale.types';
import { spotprisRoute } from 'src/app/routes';
import { isSameHour } from 'date-fns';
import { NavigationExtras, Router } from '@angular/router';
import { SanityService } from 'src/app/services/sanity/sanity.service';
import { ContractDesc } from 'src/app/services/sanity/sanity.types';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-avtale-kort',
  templateUrl: './avtale-kort.component.html',
  styleUrls: ['./avtale-kort.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule]
})
export class AvtaleKortComponent implements OnInit {
  @Input() avtale: Avtaler;
  @Input() avtalemode: number;

  timensSpotpris: string;
  today: Date;
  avtaleDesc: ContractDesc;

  showOmAvtalen: boolean;

  constructor(
    public platform: Platform,
    private sanityService: SanityService,
    private router: Router
  ) {}

  ngOnInit() {
    this.sanityService.getAvtaleDescriptions().then((res) => {
      this.avtaleDesc = res.find(
        (x) => x.key.toLowerCase() === this.avtale.produktgruppe.toLowerCase()
      );
    });
    if (this.avtale.produktgruppe === 'Spotpris') {
      this.spotprisCalculations();
    }
    this.showOmAvtalen = ['Fastpris', 'Spotpris', 'Felleskraft'].includes(
      this.avtale.produktgruppe
    );
  }

  spotprisCalculations() {
    this.today = new Date();
    const mvaMultiplier = this.avtale.mva ? 1.25 : 1;
    const denneTimen = this.avtale.priser.find((x) =>
      isSameHour(new Date(x.time), this.today)
    );
    // Regn ut hva spotprisen denne timen er for kunden, inkl påslaget deres og mva hvis gjeldende
    if (denneTimen) {
      this.timensSpotpris = (
        denneTimen.kraftpris * mvaMultiplier * 100 +
        this.avtale.paaslagOre
      )
        .toFixed(2)
        .replace('.', ',');
    }
  }

  navigateToSpot() {
    let navigationExtras: NavigationExtras = {
      state: {
        activeChart: 'Time',
        presentation: 'table'
      }
    };
    this.router.navigate([spotprisRoute], navigationExtras);
  }
}
